import { commonErrors } from '@utils/error';
import { requiredNumber, requiredString, zipCode } from '@utils/validation';
import { z } from 'zod';

export const dataConstants = {
	minNameLength: 3,
	maxResults: 20,
	defaultDistance: 20,
	defaultResults: 5,
	resultOptions: [
		{ label: 5, value: 5 },
		{ label: 10, value: 10 },
		{ label: 20, value: 20 },
	],
	distanceOptions: [
		{ label: '5 miles', value: 5 },
		{ label: '10 miles', value: 10 },
		{ label: '20 miles', value: 20 },
		{ label: '50 miles', value: 50 },
	],
	PHARMACY_ID: 'pharmacyId',
	DELIVERY_NAME: 'deliveryName',
	DELIVERY_ADDRESS: 'deliveryAddress',
};

export const testContent = {};

export const schema = z.object({
	pharmacyName: requiredString('Pharmacy name required', 3),
	pharmacyZip: zipCode,
	pharmacyDistance: requiredNumber(commonErrors.selectionRequired),
	pharmacyResults: requiredNumber(commonErrors.selectionRequired),
	pharmacyId: requiredString(commonErrors.selectionRequired),
});
